import React from 'react';

import './button.scss';

interface IPropsButton {
  wrapperClass?: string;
  message?: string | null;
  onEvent?: () => void;
  icon?: React.ReactNode;
}

const Button: React.FC<IPropsButton> = ({ message = '', wrapperClass = '', onEvent, icon }): JSX.Element => {
  return (
    <button
      className={`button-custom ${wrapperClass}`}
      onClick={onEvent}
    >
      {!!message && message}
      {!!icon && icon}
    </button>
  );
};

export default Button;
